import { render } from "./Templates.vue?vue&type=template&id=8380efde&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=ts"
export * from "./Templates.vue?vue&type=script&lang=ts"

import "./Templates.vue?vue&type=style&index=0&id=8380efde&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8380efde"

export default script